import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CSPaymentsComponent } from './cspayments.component';
import { SharedCoreModule } from '../shared-core/shared-core.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [CSPaymentsComponent],
  imports: [CommonModule, SharedModule, SharedCoreModule],
})
export class CsPaymentsModule {}
